import {Routes} from "@angular/router";

export const ProfileRoutes: Routes = [
    {
        path: "",
        loadComponent: () =>
            import("../pages/profile/profile.page").then((m) => m.ProfilePage),
    },
    {
        path: "address-container",
        loadComponent: () =>
            import("@/app/domains/shared/addresses/pages/address-container/address-container.page").then(
                (m) => m.AddressContainerPage
            ),
    },
    {
        path: "address-edit",
        loadComponent: () =>
            import("@/app/domains/shared/addresses/pages/address-edit/address-edit.page").then(
                (m) => m.AddressEditPage
            ),
    },
    {
        path: "address-container/address-edit",
        loadComponent: () =>
            import("@/app/domains/shared/addresses/pages/address-edit/address-edit.page").then(
                (m) => m.AddressEditPage
            ),
    },
    {
        path: "employee-edit",
        children: [
            {
                path: "",
                loadComponent: () =>
                    import("@/app/domains/auth/employee/pages/employee-edit/employee-edit.page").then(
                        (m) => m.EmployeeEditPage
                    ),
            },
			{
				path: "address-container",
				children: [
					{
						path: "",
						loadComponent: () =>
							import("@/app/domains/shared/addresses/pages/address-container/address-container.page").then(
								(m) => m.AddressContainerPage
							),
					},
					{
						path: "address-edit",
						loadComponent: () =>
							import("@/app/domains/shared/addresses/pages/address-edit/address-edit.page").then(
								(m) => m.AddressEditPage
							),
					},
				],
			},
        ]
    },
    {
        path: "**",
        redirectTo: "",
        pathMatch: "full",
    },
];
